import { supabase } from '../lib/supabase'
import type { Client } from '../types/index'

function rowToClient(r: Record<string, unknown>): Client {
  return {
    id:       r.id as string,
    name:     r.name as string,
    contact:  (r.contact as string) || '',
    email:    (r.email as string) || '',
    phone:    (r.phone as string) || '',
    services: (r.services as string[]) || [],
    mrr:      (r.mrr as number) || 0,
    status:   (r.status as Client['status']) || 'active',
    joinedAt: r.joined_at as string,
    avatar:   r.avatar as string | undefined,
  }
}

export async function getClients(): Promise<Client[]> {
  const { data, error } = await supabase.from('clients').select('*').order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map(rowToClient)
}

export async function createClient(c: Omit<Client, 'id'>): Promise<Client> {
  const { data, error } = await supabase.from('clients').insert({
    name: c.name, contact: c.contact, email: c.email, phone: c.phone,
    services: c.services, mrr: c.mrr, status: c.status,
    joined_at: c.joinedAt, avatar: c.avatar,
  }).select().single()
  if (error) throw error
  return rowToClient(data)
}

export async function updateClient(id: string, c: Partial<Client>): Promise<void> {
  const updates: Record<string, unknown> = {}
  if (c.name     !== undefined) updates.name     = c.name
  if (c.contact  !== undefined) updates.contact  = c.contact
  if (c.email    !== undefined) updates.email    = c.email
  if (c.phone    !== undefined) updates.phone    = c.phone
  if (c.services !== undefined) updates.services = c.services
  if (c.mrr      !== undefined) updates.mrr      = c.mrr
  if (c.status   !== undefined) updates.status   = c.status
  if (c.joinedAt !== undefined) updates.joined_at = c.joinedAt
  const { error } = await supabase.from('clients').update(updates).eq('id', id)
  if (error) throw error
}

export async function deleteClient(id: string): Promise<void> {
  const { error } = await supabase.from('clients').delete().eq('id', id)
  if (error) throw error
}
